import '/app/brewery-packages/content/content-editor-plugin-emphasis/src/Emphasis.css-raw';
export default {
  "emphasis": "about-us-b998e096-emphasis-Ihm-DG"
};